module.exports = __webpack_public_path__ + "img/2012-08-18 10.54.25.f1de5413.jpg";